import style from './style.module.scss';
import X from '../../../public/images/social/x.svg';
import Telegram from '../../../public/images/social/telegram.svg';
import Youtube from '../../../public/images/social/youtube.svg';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { TERMINAL_MAC_OS_LINKS, BROKER_LINKS } from '@/core/constants';

const Footer = () => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  return (
    <div className={style.main}>
      <div className={style.landingFooter}>
        <div className={style.mainContainer}>
          <div className={style.logo} />
          <div className={style.footMenu}>
            <div className={style.follow}>
              {t('footer_section3')}
              <div className={style.social}>
                <a target="_blank" href={t('social-href_x')} className={style.icon}>
                  <X />
                </a>
                <a target="_blank" href={t('social-href_telegram')} className={style.icon}>
                  <Telegram />
                </a>
                <a target="_blank" href={t('social-href_youtube')} className={style.icon}>
                  <Youtube />
                </a>
              </div>
            </div>
            <div className={style.col}>
              Tiger.Com
              <Link href="/">{t('footer_home_button2')}</Link>
              <Link href="/contacts">{t('footer_contacts_button1')}</Link>
              <a href="https://blog.tiger.com/" target="_blank" rel="noopener noreferrer">
                {t('header_blog_button')}
              </a>
            </div>
            <div className={style.col}>
              {t('footer_section2')}
              <Link href="/terminal">{t('footer_wnd_tp_button')}</Link>
              <a href={TERMINAL_MAC_OS_LINKS[locale]} target="_blank" rel="noopener noreferrer">
                {t('footer_mac_tp_button')}
              </a>
              <a href={BROKER_LINKS[locale]} target="_blank" rel="noopener noreferrer">
                {t('header_products_broker_redirect_button')}
              </a>
              <a href="https://dex.tiger.com/" target="_blank" rel="noopener">
                Tiger.com DEX
              </a>
            </div>
          </div>
          <div className={style.footText}>
            <div className={style.prod}>
              {t('footer_law_section1')}
              <br />
              {t('footer_law_section2')}
            </div>
            <div className={style.rights}>
              {t('footer_law_section3')}
              {false && (
                <>
                  <br />
                  {t('footer_law_section4')}
                </>
              )}
            </div>
            <div className={style.links}>
              <Link href="/policy">
                <a>{t('footer_law_privacy_button')}</a>
              </Link>
              <Link href="/terminal/terms-of-service">
                <a>{t('footer_law_terms_button')}</a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
